import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
// Custom domains serve /api on the same origin; stay same-origin so auth cookies stay first-party.
const SAME_ORIGIN = window.location.hostname !== "localhost" && new URL(BACKEND).host !== window.location.host;
export const API = `${SAME_ORIGIN ? window.location.origin : BACKEND}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

const NO_REFRESH = ["/auth/refresh", "/auth/login", "/auth/register", "/auth/logout"];
let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config;
    if (error.response?.status === 401 && orig && !orig._retry && !NO_REFRESH.some((p) => orig.url.includes(p))) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(orig);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (typeof d?.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}

export const photoUrl = (path) => (path ? `${API}/photos/${path}` : null);

export function fmtTime(iso) {
  if (!iso) return "—";
  const [, t] = iso.split("T");
  if (!t) return iso;
  let [h, m] = t.split(":").map(Number);
  const ap = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${h}:${String(m).padStart(2, "0")} ${ap}`;
}

export function fmtDate(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}
